import React, { FC } from 'react';
import Icon from "@assets/icon_config"
import './noDataFound.scss'
import { NO_DATA_FOUND } from '../../constants/constants';

interface DataNotFoundProps {
    message: string | undefined;
    tableLocale?: boolean;
}

// To display a message when no data is found
const DataNotFound: FC<DataNotFoundProps> = ({ message, tableLocale = false }) => {
    return (
        <div className={`noDataFound${tableLocale ? ' tableVector' : ''}`}>
            <Icon name="noDataFound" />
            <div className="noDataFound__text">{message}</div>
        </div>
    );
}
export default DataNotFound;


// Locale configuration for "no data found" message in AntD Table
export const TableLocale = {
    emptyText: <DataNotFound message={NO_DATA_FOUND} tableLocale />,
};
